module.exports = __webpack_public_path__ + "static/media/banner.98a8e399.jpg";